import { render, staticRenderFns } from "./BansPage.vue?vue&type=template&id=2e013167&scoped=true&"
import script from "./BansPage.vue?vue&type=script&lang=js&"
export * from "./BansPage.vue?vue&type=script&lang=js&"
import style0 from "./BansPage.vue?vue&type=style&index=0&id=2e013167&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e013167",
  null
  
)

export default component.exports